// Sublist Sidebar

function onLoad() {
  const logger = require("js-logger").get("sidebar");

  try {
    const arrow = $(".js-arrow");
    arrow.each(function() {
      const that = $(this);
      that.on("click", function(e) {
        e.preventDefault();
        arrow.find(".fas").toggleClass("fa-angle-up");
        arrow.find(".fas").toggleClass("fa-angle-down");
        that.toggleClass("open");
        that
          .parent()
          .find(".js-sub-list")
          .slideToggle("250");
      });
    });
  } catch (error) {
    logger.debug(error);
  }
}

module.exports = {
  onLoad
};



// WEBPACK FOOTER //
// ./resources/js/sidebar.js